import ConstList from '../ConstList'

const pad2 = value => String(value).padStart(2, '0')

export const rosterDateKey = (year, month, index) => {
  const day = Number(index) + 1
  return `${String(year)}-${pad2(month)}-${pad2(day)}`
}

export const isFutureRosterIndex = ({ year, month, index, todayKey }) => (
  rosterDateKey(year, month, index) > todayKey
)

export const isPastRosterIndex = ({ year, month, index, todayKey }) => (
  rosterDateKey(year, month, index) < todayKey
)

export const canApplyScheduledTimes = ({
  year,
  month,
  index,
  todayKey,
  attendance,
  fullTimeId,
  start,
  end,
  startBasic,
  endBasic
}) => {
  if (isFutureRosterIndex({ year, month, index, todayKey })) return false
  if (Number(attendance) !== Number(fullTimeId)) return false
  if (start || end) return false
  return Boolean(startBasic && endBasic)
}

/**
 * 勤怠1がこの区分の日は、時刻の欄（開始・終了・休憩・夜勤休憩）を空にする。
 *
 * 区分は呼ぶ側が渡す（勤務表では 休日・有給・代休・欠勤・特休有給）。勤怠1を選んだとき
 * 欄を空にする処理（Roster.vue の autoTime）と、定時の候補を出すかの判定
 * （showsScheduleCandidate）が同じ並びを見るので、2か所が食い違わない。
 * 値は数でも文字でもよい（比べる前に数へそろえる）。空欄は当たらない。
 */
export const clearsTimesForAttendance = (attendance, noTimeIds) => {
  if (attendance === null || attendance === undefined || attendance === '') return false
  return (noTimeIds || []).some(id => Number(id) === Number(attendance))
}

/**
 * その日の欄の下に、定時の候補（「候補 09:00」）を出すか。
 *
 * 候補は「働く日の時刻の目安」。時刻を空にする区分の日（休日・休暇・欠勤）には出さない。
 * 以前は勤怠を見ずに出していて、土日祝の行にも「候補 09:00」が並んでいた（2026-09-26）。
 * 「定時を反映」を常勤の日だけに許す canApplyScheduledTimes と同じ考え。
 */
export const showsScheduleCandidate = ({ attendance, noTimeIds }) => (
  !clearsTimesForAttendance(attendance, noTimeIds)
)

/**
 * 勤怠2を使う勤怠1の区分（午前出勤・午前有給・午前代休・午前欠勤・午前特休・早出出勤・シフト）。
 *
 * 勤務表は、勤怠1がこの並びに無い行の勤怠2を、描画のたびに空へそろえる（Roster.vue の computed afternoon）。
 * ファイル取り込みの確認（utils/rosterImport.js）が「この勤怠区分では勤怠2を使用しない」と出すのも、
 * 勤怠1がこの並びに無い行だけ。2か所が同じ並びを見るので、勤務表で入れた日と取り込んだ日で勤怠2が食い違わない。
 * 以前、取り込みは「勤怠2が必須でない区分」を「勤怠2を使わない区分」と取り違えていて、シフトの行に
 * 文を出していた（2026-10-03）。
 */
export const ATTENDANCE2_ATTENDANCE1_IDS = Object.freeze([
  ConstList.MORNING_WORK,
  ConstList.MORNING_PAID,
  ConstList.MORNING_SUBSTITUTE,
  ConstList.MORNING_DEDUCTION,
  ConstList.MORNING_SPECIAL_HOLIDAY,
  ConstList.EARLY_MORNING,
  ConstList.SHIFT
])

/**
 * 勤怠1がこの区分の日は、勤怠2を使うか。
 * 比べ方は勤務表の afternoon と同じ厳密な一致（数へそろえない。勤務表の動きを変えないため）。
 */
export const usesAttendance2 = attendance1 => ATTENDANCE2_ATTENDANCE1_IDS.includes(attendance1)

export const backendErrorMessage = (error, fallback) => {
  const message = error && error.response && error.response.data
    ? error.response.data.message
    : ''
  return String(message || fallback || '').trim()
}
